import mixpanel from 'mixpanel-browser';
import {
  EnvironmentType,
  EnvironmentVariables,
  getEnvironmentVariable,
} from '@Services/env/environment.service';

const apiKey = getEnvironmentVariable(EnvironmentVariables.VITE_APP_MIXPANEL);

const _isTrackingServiceEnabled = () => import.meta.env.VITE_APP_MODE !== EnvironmentType.LOCAL;
export const initTrackingService = () => {
  if (!_isTrackingServiceEnabled()) return;
  mixpanel.init(apiKey || '', { debug: import.meta.env.MODE === 'development' });
  mixpanel.track('Mixpanel Initialized', { appVersion: '1' }); // @TODO check with devOps
};

export const identifyTrackingServiceUser = (customerId: string) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!customerId) {
    mixpanel.reset();
  } else {
    mixpanel.identify(customerId);
  }
};

export const setPeopleProperty = (props = {}) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!props) return;
  mixpanel.people.set(props);
};

export const trackEvent = (eventName: string, props?: object) => {

  if (!_isTrackingServiceEnabled()) return;
  if (!mixpanel.track) return;
  mixpanel.track(eventName, props);
};
